import React from 'react';
import { TableCell, TableRow, IconButton } from '@mui/material';
import { DebounceInput } from 'react-debounce-input';
import DeleteIcon from '@mui/icons-material/Delete';

import { CssTextField } from '../../../../../components/others/CssTextField';
import { validateValues, validateRequiredFields } from '../../../../../services/functions';

export const Row = React.forwardRef((props, ref) => {
  const { row, index, removeProductCallback, updateProductCallback } = props;
  const [participantsFrom, setParticipantsFrom] = React.useState(row.participantsFrom || '');
  const [participantsTo, setParticipantsTo] = React.useState(row.participantsTo || '');
  const [grossValue, setGrossValue] = React.useState(row.grossValue || '');
  const [errors, setErrors] = React.useState([]);
  const [requiredFields, setRequiredFields] = React.useState([`participantsFrom${index}`, `participantsTo${index}`, `grossValue${index}`]);
  const validateObject = { id: index, errors, requiredFields };
  React.useImperativeHandle(ref, () => ({ getErrors: () => validateObject }), [errors]);

  React.useEffect(() => {
    if (participantsFrom && participantsTo && grossValue) {
      setRequiredFields([]);
    }
  }, []);

  React.useEffect(() => {
    updateProductCallback(constructProduct());
  }, [participantsFrom, participantsTo, grossValue]);

  const transform = val => val && (!isNaN(val) || !isNaN(parseFloat(val))) ? val.toString().replace(',', '.') : val;

  const constructProduct = () => (
    { id: row.id, participantsFrom, participantsTo, grossValue });

  const validateValue = (value, type, maxLength, name, required) => {
    if (type === 'float') {
      setErrors(validateValues(errors, transform(value), type, maxLength, name));
    } else {
      setErrors(validateValues(errors, value, type, maxLength, name));
    }
    if (required) {
      setRequiredFields(validateRequiredFields(requiredFields, value, name, required));
    }
  };

  return (
    <React.Fragment>
      <TableRow key={row}>
        <TableCell align="center">
          <DebounceInput
            name={`participantsFrom${index}`}
            debounceTimeout={1000}
            value={participantsFrom}
            element={CssTextField}
            onChange={e => {
              validateValue(
                e.target.value,
                'number',
                null,
                e.target.name,
                true
              );
              setParticipantsFrom(e.target.value);
            }}
            variant="outlined"
            error={errors.includes(`participantsFrom${index}`) || requiredFields.includes(`participantsFrom${index}`) ? true : false}
            helperText={
              errors.includes(`participantsFrom${index}`)
                ? 'Proszę wprowadzić odpowiednią liczbę całkowitą'
                : requiredFields.includes(`participantsFrom${index}`)
                  ? 'To pole jest wymagane'
                  : ''
            }
          />
        </TableCell>
        <TableCell align="center">
          <DebounceInput
            name={`participantsTo${index}`}
            debounceTimeout={1000}
            value={participantsTo}
            element={CssTextField}
            onChange={e => {
              validateValue(
                e.target.value,
                'number',
                null,
                e.target.name,
                true
              );
              setParticipantsTo(e.target.value);
            }}
            variant="outlined"
            error={errors.includes(`participantsTo${index}`) || requiredFields.includes(`participantsTo${index}`) ? true : false}
            helperText={
              errors.includes(`participantsTo${index}`)
                ? 'Proszę wprowadzić odpowiednią liczbę całkowitą'
                : requiredFields.includes(`participantsTo${index}`)
                  ? 'To pole jest wymagane'
                  : ''
            }
          />
        </TableCell>
        <TableCell align="center">
          <DebounceInput
            name={`grossValue${index}`}
            debounceTimeout={1000}
            value={grossValue}
            element={CssTextField}
            onChange={e => {
              validateValue(
                e.target.value,
                'float',
                null,
                e.target.name,
                true
              );
              setGrossValue(e.target.value);
            }}
            variant="outlined"
            error={errors.includes(`grossValue${index}`) || requiredFields.includes(`grossValue${index}`) ? true : false}
            helperText={
              errors.includes(`grossValue${index}`)
                ? 'Proszę wprowadzić odpowiednią liczbę'
                : requiredFields.includes(`grossValue${index}`)
                  ? 'To pole jest wymagane'
                  : ''
            }
          />
        </TableCell>
        <TableCell align="center">
          <IconButton
            color="error"
            variant="contained"
            onClick={() => removeProductCallback(row.id)}
          >
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
});
